import { gql } from 'apollo-boost';

export const GET_ACTIVITIES = gql`
  query {
    learning_log_activities {
      activity
    }
  }
`;
